import { datadogLogs } from '@datadog/browser-logs';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import App from './App';
import Config from './Config';
import { store } from './Redux/store';
import { BackendAccessProvider } from 'Backend';
import { NotificationsContextProvider } from 'Components/Notifications';

const livePage = !!window?.location?.href && !window.location.href.includes('localhost');

datadogLogs.init({
    clientToken: 'pub2018609eaf56b078a44af03fe416ffbc',
    forwardConsoleLogs: livePage ? 'all' : [],
    forwardErrorsToLogs: livePage,
    sampleRate: 100,
    site: 'datadoghq.com',
    service: 'paytron-webapp',
    version: 'latest',
});
datadogLogs.addLoggerGlobalContext('environment', livePage ? Config.datadogEnvironment : 'localhost');

const queryClient = new QueryClient();

const rootElement = document.getElementById('root')!; // eslint-disable-line @typescript-eslint/no-non-null-assertion -- this better exist
const root = createRoot(rootElement);

root.render(
    <StrictMode>
        <Provider store={store}>
            <BackendAccessProvider>
                <NotificationsContextProvider>
                    <QueryClientProvider client={queryClient}>
                        <App />
                        <ReactQueryDevtools initialIsOpen={false} />
                    </QueryClientProvider>
                </NotificationsContextProvider>
            </BackendAccessProvider>
        </Provider>
    </StrictMode>
);
